import type { LegendLite, SportGroup } from "./api";

export interface LegendWithMeta extends LegendLite {
  sport: string;
  level: string;
  team: string;
}

function tokens(value: string): string[] {
  return value.toLocaleLowerCase().match(/[\p{L}\p{N}]+/gu) ?? [];
}

export function matchesLegendSearch(
  legend: Pick<LegendWithMeta, "name" | "team" | "position" | "sport">,
  query: string,
): boolean {
  const normalizedQuery = query.trim();
  if (normalizedQuery.length < 2) return true;

  const queryTokens = tokens(normalizedQuery);
  const legendTokens = new Set(tokens([legend.name, legend.team, legend.position, legend.sport].join(" ")));
  return queryTokens.every((queryToken) => [...legendTokens].some((legendToken) => legendToken.startsWith(queryToken)));
}

export function flattenLegendTaxonomy(sports: SportGroup[]): LegendWithMeta[] {
  const legends: LegendWithMeta[] = [];
  const seen = new Set<string>();
  for (const sport of sports) {
    for (const level of sport.levels) {
      for (const team of level.teams) {
        for (const legend of team.legends) {
          if (seen.has(legend.id)) continue;
          seen.add(legend.id);
          legends.push({ ...legend, sport: sport.sport, level: level.level, team: team.team });
        }
      }
    }
  }
  return legends;
}

export function teamsForSport(sports: SportGroup[], selectedSport: string | null): string[] {
  if (selectedSport === null) return [];
  const teams = new Set<string>();
  for (const sport of sports) {
    if (sport.sport !== selectedSport) continue;
    for (const level of sport.levels) {
      for (const team of level.teams) teams.add(team.team);
    }
  }
  return [...teams].sort();
}
